<template>
    <button
        class="a-button button"
        :class="`btn--${theme}`"
        type="button"
        :disabled="disabled"
        
        @click="onClick"
    >
        <img
            v-if="loading"
            src="../../../assets/images/loaders/loader.svg"
            class="button__loader"
            :alt="`${$t('button__loader')}`"
        />
        <span 
            class="button__container"
            v-else
        >
            <slot name="left" />
            <span class="button__text">
                {{ text }}
            </span>
            <slot name="right" />
        </span>
    </button>
</template>

<script>
export default {
    name: 'AButton',
    props: {
        text: {
            type: String,
            default: 'text'
        },
        theme: {
            type: String,
            default: 'primary',
            validator: val => ['primary', 'secondary', 'white', 'dark'].includes(val)
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClick(evt) {
            this.$emit('onClick', evt);
        }
    }
}
</script>

<style lang="scss">
@import "a-button";
</style>
